export const testDetailConstants = {
  TEST_DETAIL_LOADING: "TEST_DETAIL_LOADING",
  TEST_DETAIL_SUCCESS: "TEST_DETAIL_SUCCESS",
  TEST_DETAIL_FAILURE: "TEST_DETAIL_FAILURE",
};

export const downloadTestFileConstants = {
  DWNLD_TEST_FILE_LOADING: "DWNLD_TEST_FILE_LOADING",
  DWNLD_TEST_FILE_SUCCESS: "DWNLD_TEST_FILE_SUCCESS",
  DWNLD_TEST_FILE_FAILURE: "DWNLD_TEST_FILE_FAILURE",
};
